import React from "react";
import Button from "components/CustomButtons/Button.jsx";

import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";


import withStyles from "@material-ui/core/styles/withStyles";

import loginPageStyle from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.jsx";

import customSelectStyle from "assets/jss/material-dashboard-pro-react/customSelectStyle.jsx";
import regularFormsStyle from "assets/jss/material-dashboard-pro-react/views/regularFormsStyle";
import { getApiHeaders } from "../../assets/helpers/apiHelper";
import axios from "axios";
import { API_ROOT } from 'api-config';

const style = {
  infoText: {
    fontWeight: "300",
    margin: "10px 0 30px",
    textAlign: "center"
  },
  answerOptions: {
    paddingLeft: '30px'
  },
  ...customSelectStyle,
  ...regularFormsStyle,
  ...loginPageStyle
};

class MarketingPlanDisplay extends React.Component {

  constructor(props) {
    super(props);
    this._isMounted = false;
    var userId = sessionStorage.getItem('userId')
    var templateId;
    if (props.templateId) {
      templateId = props.templateId
    }
    this.state = {
      userId: userId,
      templateId: templateId,
      activeStep: 0,
      theQuestion: '',
      questionType: '',
      answerOptions: [],
      questionId: '',
      numSteps: 0,
      questions: '',
      answers: {},
      planText: [{'line': 'loading...'}],
      generateMarketingPlanButtonDisabled: true,
      officeName: '',
      officeAddress1: '',
      officeAddress2: '',
      officeAddressCity: '',
      officeAddressState: '',
      officeAddressZip: ''
    };

  }
  componentDidMount() {
    this._isMounted = true;
    this.getPlanText()
    this.getOfficeName()
    this.getOfficeAddress()
  }

  componentWillUnmount() {
    this._isMounted = false;
  }

  getPlanText() {
    axios.get(`${API_ROOT}/marketing/templateDisplay/?templateId=`+this.state.templateId+`&userId=`+this.state.userId, {headers: getApiHeaders()})
      .then(res => this.setPlanText(res.data));
  }

  setPlanText(planText) {
    if (this._isMounted) {
      var planTextDisplay = []
      var line = { 'fontSize': '16px', 'fontColor': '', 'fontWeight': '', 'line': planText.intro }
      var lineArray = ""
      planTextDisplay.push(line)

      const allAnswers = planText.answers
      for (var answer in allAnswers) {
        line = { 'fontSize': '20px', 'fontColor': '', 'fontWeight': 'bold', 'line': allAnswers[answer].printText }
        planTextDisplay.push(line)

        //split line breaks
        lineArray = allAnswers[answer].answer.split("\n\n")
        for (var lineChunk in lineArray) {
          line = { 'fontSize': '16px', 'fontColor': '', 'fontWeight': '', 'line': lineArray[lineChunk] }
          planTextDisplay.push(line)
        }

      }

      line = { 'fontSize': '16px', 'fontColor': '', 'fontWeight': '', 'line': planText.closing }
      planTextDisplay.push(line)

      this.setState({
        planText: planTextDisplay
      })
    }
  }


  getOfficeName() {
    axios.get(`${API_ROOT}/user/?userId=`+this.state.userId, {headers: getApiHeaders()})
      .then(res => this.setOfficeName(res.data));
  }

  setOfficeName(res) {
    if (this._isMounted) {
      this.setState({
        officeName: res.last_name
      })
    }
  }

  getOfficeAddress() {
    axios.get(`${API_ROOT}/address/?userId=`+this.state.userId, {headers: getApiHeaders()})
      .then(res => this.setOfficeAddress(res.data));
  }

  setOfficeAddress(res) {
    if (this._isMounted) {
      this.setState({
        officeAddress1: res.address1,
        officeAddress2: res.address2,
        officeAddressCity: res.city,
        officeAddressState: res.state,
        officeAddressZip: res.zip
      })
    }
  }

  printPlan = () => {
    const printableElement = document.getElementById('planTextDisplay').innerHTML;
    let printWindow = window.open('', 'PRINT', 'height=650,width=900,top=100,left=150');

    printWindow.document.write(`<html><head><title>Marketing Plan</title>`);
    printWindow.document.write(`</head><body style='font-family: "Clear Sans", sans-serif; color: #5a5a5b'>`);
    printWindow.document.write(printableElement);
    printWindow.document.write('</body></html>');

    printWindow.document.close(); // necessary for IE >= 10
    printWindow.focus(); // necessary for IE >= 10*/

    printWindow.print();
    printWindow.close();

    return true;
  }

    render() {
    // const { classes } = this.props;
    return (
      <div>
        <GridContainer>
          <GridItem xs={12} sm={12}>
            <Button
              onClick={this.printPlan}
              color="cirrusBlue"
              size="sm"
            >
              print
            </Button>

                <div id="planTextDisplay">
                  <p><img src="https://storage.googleapis.com/static-assets-cirrus/cirrusLogo_300x155.png" width="150px" alt="Cirrus Dental logo" /></p>
                  <p>Marketing plan for</p>
                  <p>{this.state.officeName}<br />
                    {this.state.officeAddress1}<br />
                    <span style={this.state.officeAddress2 ? {} : { display: 'none' }}>
                      {this.state.officeAddress2}<br />
                    </span>

                    {this.state.officeAddressCity}, {this.state.officeAddressState} {this.state.officeAddressZip}

                  </p>
                  {this.state.planText.map((textOfLine, key) =>
                    <p style={{fontSize: textOfLine.fontSize, color: textOfLine.fontColor, fontWeight: textOfLine.fontWeight}} key={key}>{textOfLine.line}</p>
                  )}
                </div>

          </GridItem>
        </GridContainer>
      </div>

    );
  }
}

export default withStyles(style)(MarketingPlanDisplay);
